import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
// import { RoleForm } from "./RoleForm";
import { axiosNewInstance } from "../../config/Api";
import { PermissionForm } from "./PermissionForm";
import LangData from "../common/LangData";

export default function Permission() {
  const history = useHistory();
  const [showForm, setShowForm] = useState(false);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ search: "", status: "" });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [editRole, setEditRole] = useState({});
  const token = localStorage.getItem("authToken");

  const fetchRoles = async (page = 1) => {
    const FETCH_ROLE_URL = "/api-app/get-roles";
    setLoading(true);
    try {
      const response = await axiosNewInstance.post(
        FETCH_ROLE_URL,
        {
          page,
          name: filters.search || undefined,
          status: filters.status || undefined,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const roleData = response.data?.data?.roles || {};
      setRoles(roleData?.data || []);
      setCurrentPage(roleData?.current_page || 1);
      setTotalPages(roleData?.last_page || 1);
      console.log("Fetched roles:", roleData?.data || []);
    } catch (error) {
      if (error.response?.data?.status === 0) {
        localStorage.removeItem("authToken");
        history.push("/login");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleAssignPermission = (data) => {
    console.log("Editing role...", data);
    setShowForm(true);
    setEditRole(data);
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const handleFormSubmit = () => {
    fetchRoles();
    setShowForm(false);
    setEditRole({});
  };

  return (
    <div className="container mt-4">
 

      {/* Role Form */}
      {showForm && (
        <div className="mb-3">
          <PermissionForm editRole={editRole} setEditRole={setEditRole} showForm={showForm} setShowForm={setShowForm}  onFormSubmit={handleFormSubmit} />
        </div>
      )}

      {/* Role Table */}
      {!showForm && (
        <div className="card">
          {/* <div className="card-header bg-primary text-white">
          <h5 className="mb-0">Role List</h5>
        </div> */}
          <div className="card-body">
            {loading ? (
              <p>Loading roles...</p>
            ) : (
              <>
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th scope="col"><LangData keyname="label_serial" /></th>
                      <th scope="col"><LangData keyname="label_role_name" /></th>
                      <th scope="col"><LangData keyname="label_status" /></th>
                      <th scope="col" className="text-center">
                      <LangData keyname="label_action" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {roles.length > 0 ? (
                      roles.map((role, index) => (
                        <tr key={role.id}>
                          <td>{index + 1 + (currentPage - 1) * 10}</td>
                          <td>{role.name}</td>
                          <td>
                            {role.status === 1
                              ? "Active"
                              : role.status === 0
                              ? "Inactive"
                              : "Unknown"}
                          </td>

                          <td className="text-center">
                            <button
                              className="btn btn-sm btn-outline-warning"
                              onClick={() => handleAssignPermission(role)}
                            >
                              Assign Permission
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center">
                          No roles found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>

                {/* Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => fetchRoles(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Prev
                  </button>
                  <span>
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => fetchRoles(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
